
import { Toast, PullRefresh, SwipeCell, Dialog } from "vant";
import { Component, Vue, Watch } from "vue-property-decorator";
import NavBar from "@/components/navBar.vue";
import { getUserInfo, countIdCard } from "@/req/user";
@Component({
  components: { PullRefresh, SwipeCell, NavBar },
})
export default class Logout extends Vue {
  public count = 0;
  public isLoading = false;
  public name = "胡宇桐";
  public idcard = "3333333333333333";
  public num = "";
  //   @Watch("code")
  //   public codeChange() {
  //       this.
  //   }
  public onClickLeft() {
    // this.$router.push("/my");
    this.$fn.sendIos(1);
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public mounted() {
    const obj: any = this.$fn.parseQuery(window.location.href);
    if (obj.token) {
      this.$fn.cookies.removeToken();
      this.$fn.cookies.setToken(obj.token);
      this.$fn.cookies.setShowNav(1);
    }
    this.getInfo();
    this.getCountIdCard();
  }
  public redirectToAuth() {
    Dialog.alert({
      title: "提醒",
      message: "您还未实名认证，请前往认证",
      theme: "round-button",
    }).then(() => {
      this.$router.push("/verificationCode");
    });
  }
  public async getInfo() {
    const storeUserInfo: any = this.$store.state.user.info || {};
    const hasLoadedUserInfo =
      typeof storeUserInfo.auth_status !== "undefined" ||
      !!storeUserInfo.real_name ||
      !!storeUserInfo.idcard;
    if (hasLoadedUserInfo) {
      if (storeUserInfo.auth_status != 1) {
        this.redirectToAuth();
      }
      return;
    }
    const res = await getUserInfo();
    if (res.code == 200) {
      await this.$store.dispatch("user/authInfo", res.data.userinfo);
      if (res.data.userinfo.auth_status != 1) {
        this.redirectToAuth();
      }
      return;
    }
    Dialog.alert({
      title: "提醒",
      message: res.msg,
      theme: "round-button",
    }).then(() => {
      this.$router.push("/verificationCode");
    });
  }
  public async getCountIdCard() {
    const res = await countIdCard();
    if (res.code == 200) {
      this.num = res.data.count;
    }
  }
  // 唤起IOS联系客服
  public sendService() {
    (window as any).sendService();
  }
}
